
import { Vue, Component } from "vue-property-decorator";
import newsItem from "./components/news-item/index.vue";
import customSwiper from "@/views/kaizhou-shuai-video/components/custom-swiper/index.vue";
import request from "@/api";
import { List, Icon, PullRefresh } from "vant";
import {
  commonJumpNewsDetail,
  setWechatShare
} from "@/views/kaizhou-shuai-video/hooks";

@Component({
  name: "news",
  methods: { commonJumpNewsDetail },
  components: {
    "news-item": newsItem,
    "custom-swiper": customSwiper,
    "van-list": List,
    "van-icon": Icon,
    "van-pull-refresh": PullRefresh
  }
})
export default class news extends Vue {
  list = [];
  carouselList = [];
  loading = false;
  finished = false;
  columnId = "";
  async created() {
    const ids = this.$route.query.ids as string;
    this.columnId = await this.getColumId(ids);
    const res = await request.listNews(this.columnId);
    const result = this.distinguishData(res.data);
    this.carouselList = result.carouselTemp;
    this.list = result.listTemp;
    setWechatShare();
  }

  mounted() {
    document.title = (this.$route.query.title || "") as string;
    this.handleShowHeader();
  }

  activated() {
    setWechatShare();
  }

  async getColumId(ids: string): Promise<string> {
    const temp = await request.seatNews(ids);
    return temp.data[0].target.id;
  }

  distinguishData(data: any) {
    const carouselTemp: any = [];
    const listTemp: any = [];
    data?.forEach((item: any) => {
      if (item.listViewCode === "CAROUSEL_LIST@2") {
        carouselTemp.push(...item.dataList);
      } else {
        listTemp.push(item);
      }
    });
    return {
      carouselTemp,
      listTemp
    };
  }

  async onLoad() {
    const lastEl: any = (this.list.lastChild as any).dataList[0];
    const lastId = lastEl?.infoClassifyId;
    const res = await request.listNews(this.columnId, lastId);
    const result = this.distinguishData(res.data);
    const data = result.listTemp;
    this.loading = false;
    this.list = this.list.concat(data);
    if (data.length < 10) {
      this.finished = true;
    }
  }
  isLoading = false;
  async onRefresh() {
    const res = await request.listNews(this.columnId);
    const result = this.distinguishData(res.data);
    this.carouselList = result.carouselTemp;
    this.list = result.listTemp;
    this.isLoading = false;
  }

  isShowHeader = true;
  handleShowHeader() {
    if (window.history.length <= 1) {
      this.isShowHeader = false;
    }
  }
}
